(function () {
  'use strict';
  var reviewPopupReady = false;

  function initReviewPopup() {
    if (document.body.dataset.reviewPopupBound === 'true') {
      return;
    }
    document.body.dataset.reviewPopupBound = 'true';

    var currentImages = [];
    var currentIndex = 0;

    function getPopupNodes() {
      var popup = document.querySelector('.review-popup');
      if (!popup) {
        return null;
      }
      return {
        popup: popup,
        leftTarget: popup.querySelector('.review-popup-left'),
        rightTarget: popup.querySelector('.review-popup-right'),
        nameTarget: popup.querySelector('.review-popup-right-profile-name'),
        badgeTarget: popup.querySelector('.review-popup-right-profile-name-badge'),
        timeTarget: popup.querySelector('.review-popup-right-profile-reciew-time'),
        ratingTarget: popup.querySelector('.review-popup-right-rating'),
        titleTarget: popup.querySelector('.review-popup-right-title'),
        mainImageTarget: popup.querySelector('.review-popup-left-main-image'),
        otherImagesTarget: popup.querySelector('.review-popup-right-anthor-image'),
        contentTarget: popup.querySelector('.review-popup-right-content'),
        actionsTarget: popup.querySelector('.review-popup-right-review-actions'),
        prevArrow: popup.querySelector('.review-popup-left-arrow-prev'),
        nextArrow: popup.querySelector('.review-popup-left-arrow-next')
      };
    }

    function clearElement(target) {
      if (target) {
        target.replaceChildren();
      }
    }

    function setText(target, source) {
      if (!target) {
        return;
      }
      var text = source ? source.textContent.trim() : '';
      target.textContent = text;
    }

    function setProfileName(target, source) {
      if (!target) {
        return;
      }
      var text = source ? source.textContent.trim() : '';
      var badgeNode = target.querySelector('.review-popup-right-profile-name-badge');
      clearElement(target);
      if (text) {
        target.appendChild(document.createTextNode(text));
      }
      if (badgeNode) {
        target.appendChild(badgeNode);
      }
    }

    function setClone(target, source) {
      if (!target) {
        return;
      }
      clearElement(target);
      if (source) {
        target.appendChild(source.cloneNode(true));
      }
    }

    function getFullBodyParagraph(review) {
      if (!review) {
        return null;
      }
      var fullBodyParagraph = review.querySelector('.jdgm-rev__body:not(.is-truncated)');
      if (!fullBodyParagraph) {
        return null;
      }
      return fullBodyParagraph;
    }

    function syncFullBodyParagraph(contentTarget, review, retryCount) {
      if (!contentTarget || !review) {
        return;
      }
      var fullBodyParagraph = getFullBodyParagraph(review);
      if (fullBodyParagraph) {
        contentTarget.appendChild(fullBodyParagraph.cloneNode(true));
        return;
      }
      if (retryCount >= 8) {
        return;
      }
      window.setTimeout(function () {
        syncFullBodyParagraph(contentTarget, review, retryCount + 1);
      }, 40);
    }

    function bindDragScroll(track) {
      if (!track || track.dataset.dragScrollBound === 'true') {
        return;
      }
      track.dataset.dragScrollBound = 'true';
      var dragging = false;
      var pointerId = null;
      var startX = 0;
      var startScrollLeft = 0;
      var hasDragged = false;

      function stopDrag(event) {
        if (!dragging) {
          return;
        }
        if (event && pointerId !== null && event.pointerId !== pointerId) {
          return;
        }
        dragging = false;
        pointerId = null;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }
        dragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        hasDragged = false;
        track.classList.add('is-dragging');
        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(pointerId);
        }
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging || event.pointerId !== pointerId) {
          return;
        }
        var deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 2) {
          hasDragged = true;
        }
        track.scrollLeft = startScrollLeft - deltaX;
        if (hasDragged) {
          event.preventDefault();
        }
      });

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
      track.addEventListener('lostpointercapture', stopDrag);

      track.addEventListener('click', function (event) {
        if (!hasDragged) {
          return;
        }
        hasDragged = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    function updateCarousel(index) {
      var popupNodes = getPopupNodes();
      if (!popupNodes || currentImages.length === 0) return;

      if (index < 0) index = currentImages.length - 1;
      if (index >= currentImages.length) index = 0;

      currentIndex = index;

      // Update Main Image
      clearElement(popupNodes.mainImageTarget);
      var mainPic = currentImages[currentIndex].cloneNode(true);

      // Prevent link behavior on main image
      if (mainPic.tagName.toLowerCase() === 'a') {
        mainPic.addEventListener('click', function (e) { e.preventDefault(); });
      } else {
        var link = mainPic.querySelector('a');
        if (link) {
          link.addEventListener('click', function (e) { e.preventDefault(); });
        }
      }

      popupNodes.mainImageTarget.appendChild(mainPic);

      // Update Thumbnails Active State
      var thumbs = popupNodes.otherImagesTarget.children;
      for (var i = 0; i < thumbs.length; i++) {
        var thumb = thumbs[i];
        if (i === currentIndex) {
          thumb.classList.add('is-active');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.classList.remove('is-active');
        }
      }
    }

    function showPopup() {
      var popupNodes = getPopupNodes();
      if (!popupNodes) {
        return;
      }
      var popup = popupNodes.popup;
      popup.classList.add('is-active');
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function hidePopup() {
      var popupNodes = getPopupNodes();
      if (!popupNodes) {
        return;
      }
      var popup = popupNodes.popup;
      popup.classList.remove('is-active');
      popup.style.display = '';
      document.body.style.overflow = '';
    }

    var popupNodesInitial = getPopupNodes();
    if (popupNodesInitial) {
      if (popupNodesInitial.prevArrow) {
        popupNodesInitial.prevArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          updateCarousel(currentIndex - 1);
        });
      }
      if (popupNodesInitial.nextArrow) {
        popupNodesInitial.nextArrow.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          updateCarousel(currentIndex + 1);
        });
      }
      // Bind Drag Scroll
      if (popupNodesInitial.otherImagesTarget) {
        popupNodesInitial.otherImagesTarget.classList.remove('is-dragging');
        popupNodesInitial.otherImagesTarget.style.touchAction = 'auto';
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      if (target.closest('.review-popup-close')) {
        hidePopup();
      }
      var popupNodes = getPopupNodes();
      if (popupNodes && target === popupNodes.popup) {
        hidePopup();
      }
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      var trigger = target.closest('.jdgm-review-widget .jdgm-rev-widg__reviews .jdgm-rev .jdgm-rev__body-read-more');
      if (!trigger) {
        return;
      }

      var popupNodes = getPopupNodes();
      if (!popupNodes) {
        return;
      }

      var review = trigger.closest('.jdgm-rev');
      if (!review) {
        return;
      }

      event.preventDefault();

      setProfileName(popupNodes.nameTarget, review.querySelector('.jdgm-rev__author'));
      setClone(popupNodes.badgeTarget, review.querySelector('.jdgm-rev__buyer-badge-wrapper'));
      setClone(popupNodes.timeTarget, review.querySelector('.jdgm-rev__timestamp'));
      setClone(popupNodes.ratingTarget, review.querySelector('.jdgm-rev__rating'));
      setText(popupNodes.titleTarget, review.querySelector('.jdgm-rev__title'));

      clearElement(popupNodes.mainImageTarget);
      clearElement(popupNodes.otherImagesTarget);

      var reviewImages = review.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link');
      currentImages = Array.from(reviewImages);
      currentIndex = 0;

      if (currentImages.length > 0) {

        if (popupNodes.prevArrow) popupNodes.prevArrow.style.display = currentImages.length > 1 ? 'flex' : 'none';
        if (popupNodes.nextArrow) popupNodes.nextArrow.style.display = currentImages.length > 1 ? 'flex' : 'none';

        currentImages.forEach(function (pic, index) {
          var thumb = pic.cloneNode(true);
          // Ensure thumb doesn't trigger default link behavior
          if (thumb.tagName.toLowerCase() === 'a') {
            thumb.addEventListener('click', function (e) { e.preventDefault(); });
          }

          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            updateCarousel(index);
          });

          popupNodes.otherImagesTarget.appendChild(thumb);
        });
        updateCarousel(0);
      } else {
        if (popupNodes.prevArrow) popupNodes.prevArrow.style.display = 'none';
        if (popupNodes.nextArrow) popupNodes.nextArrow.style.display = 'none';
      }

      var bodyParagraph = review.querySelector('.jdgm-rev__body.is-truncated');
      setClone(popupNodes.contentTarget, bodyParagraph);
      syncFullBodyParagraph(popupNodes.contentTarget, review, 0);
      setClone(popupNodes.actionsTarget, review.querySelector('.jdgm-rev__actions'));

      if (popupNodes.mainImageTarget && popupNodes.otherImagesTarget && popupNodes.leftTarget && popupNodes.rightTarget) {
        if (!popupNodes.mainImageTarget.hasChildNodes() && !popupNodes.otherImagesTarget.hasChildNodes()) {
          popupNodes.leftTarget.style.display = 'none';
          popupNodes.rightTarget.style.width = '100%';
        } else {
          popupNodes.leftTarget.style.display = '';
          popupNodes.rightTarget.style.width = '';
        }
      }
      showPopup();
    }, true);

    reviewPopupReady = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewPopup);
  } else {
    initReviewPopup();
  }
})();
